<template>
    <input type="text" class="form-control" :name="name" :id="name" ref="dateInput" required>
</template>

<script>
import { setupDatepicker, teardownDatepicker } from '../base/functions';
import { newDate } from '../../common/calendar';

export default {
    props: {
        name: String,
        defaultDate: Object,
        onSelection: Function
    },

    methods: {
        setupDatepicker(){
            const el = this.$refs.dateInput;
            if(this.defaultDate)
                el.value = this.defaultDate.dateString;

            setupDatepicker(el, dateTxt => {
                const [dateStr, monthStr, yearStr] = dateTxt.split('/');
                const date = newDate(yearStr, monthStr, dateStr);

                this.onSelection(date);
            });
        },
        teardownDatepicker(){
            teardownDatepicker(this.$refs.dateInput);
        }
    },

    mounted(){
        this.setupDatepicker();
    },
    beforeUnmount(){
        this.teardownDatepicker();
    }
}
</script>
